module.exports = __webpack_public_path__ + "media/images/icons/action-undo-a5ba110d8151ac0a111c41e48fdf4760.svg";